export default __webpack_public_path__ + "assets/search_results_obj.9b46930807750f23133f349fe8d69572.svg";